import { motion } from "framer-motion";
import { MapPin, ShieldCheck, Droplet, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PILLARS = [
  [MapPin, "Local Australian", "Owned & operated in Perth"],
  [ShieldCheck, "Fully Licensed", "and insured — Licence PL9967"],
  [Droplet, "Water Corporation", "Waterwise plumber"],
  [BadgeCheck, "Over 15 Years", "of hands-on experience"],
];

export const WhyUs = () => (
  <section id="why-us" className="relative overflow-hidden bg-white py-24 lg:py-32" data-testid="why-us-section">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 lg:grid-cols-12 lg:px-10">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Why Plumberoo</Eyebrow>
        <h2 className="font-display text-4xl font-extrabold leading-[1] tracking-tight text-[#0F2B5B] sm:text-6xl">Honest plumbing, done right the first time.</h2>
        <p className="mt-6 max-w-md text-base text-slate-600 md:text-lg">
          We turn up when we say we will, explain the fix in plain English, and leave your place cleaner than we found it.
        </p>
        <div className="relative mt-10 aspect-[16/10] overflow-hidden rounded-[1.75rem] rounded-br-[6rem]">
          <img src="/images/work-detail.jpg" alt="Plumber tightening a brass fitting under a sink" className="h-full w-full object-cover" />
        </div>
      </Reveal>
      <div className="grid gap-5 sm:grid-cols-2 lg:col-span-7 lg:pl-10" data-testid="trust-badges">
        {PILLARS.map(([Icon, a, b], i) => (
          <Reveal key={a} delay={i * 0.08}>
            <motion.div whileHover={{ y: -4 }} className="group flex h-full flex-col justify-between rounded-[1.5rem] border border-slate-200 bg-[#FAF9F6] p-8 transition-colors duration-300 hover:border-[#FF6B00]" data-testid={`trust-badge-${i}`}>
              <span className="font-display text-sm font-bold text-slate-600">0{i + 1}</span>
              <div className="mt-14">
                <Icon className="h-10 w-10 text-[#1E6FE0] transition-transform duration-500 group-hover:scale-110" strokeWidth={1.6} />
                <h3 className="font-display mt-5 text-2xl font-extrabold text-[#0F2B5B]">{a}</h3>
                <p className="mt-1 text-slate-600">{b}</p>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
